import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import SwitchButton from 'src/components/switchButton/index.tsx';
import Slider from "../../../../components/slider";
import styles from './styles.module.scss';
import PrivacyPolicyConfirmationPage from './PrivacyPolicyConfirmationPage.jsx';
import { toast } from 'react-toastify';
import { localizedStrings } from 'src/localization/index.jsx';
import MandatoryConsentImage from 'src/legacy/images/mandatory_consent.png'
import OptionalConsentImage from 'src/legacy/images/optional_consent.png'
import NoneConsentImage from 'src/legacy/images/none_consent.png'
import Toast from 'src/components/toast/index.tsx';

class PrivacyPolicyControlView extends React.Component {
  static contextTypes = {
    store: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props);

    const privacyPolicy = this.props.account && this.props.account.privacyPolicy;

    this.state = {
      enabledCustomPrivacyPolicy: privacyPolicy && privacyPolicy.customPrivacyPolicy,
      customPrivacyPolicyUrl: privacyPolicy && privacyPolicy.customPrivacyPolicy ? privacyPolicy.url : '',
      errors: {},
      consentType: privacyPolicy && privacyPolicy.consentType,
      enabledGeoLocation: privacyPolicy && privacyPolicy.enabledGeoLocation,
      showPrivacyPolicyConfirmation: false,
    }

    this.onToggleChange = this.onToggleChange.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);

    this.localizedKeywords = localizedStrings.keywords;
    this.localizedCommons = localizedStrings.commons;
    this.localizedLoading = this.localizedCommons.loading;
    this.localizedCommonsActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedPrivaryPolicy = this.localizedSettings.account.privacy_policy;
  }

  componentWillReceiveProps(nextProps) {
    console.log('nextProps', nextProps)
    if (nextProps.updated && !nextProps.error) {
      toast(
        <Toast.Sucess
          message={this.localizedPrivaryPolicy.toast.description}
        />, {
        autoClose: 3000,
      })
      this.setState({
        showPrivacyPolicyConfirmation: false,
        success: true,
      })
    }
    }
  
  _handlePolicyChange(value) {
    this.setState({
      enabledCustomPrivacyPolicy: value,
      errors: {}
    });
  }

  _handleConsentTypeChange(type) {
    this.setState({
      consentType: type
    });
  }

  onToggleChange = () => {
    this.setState((prevState) => ({
      enabledGeoLocation: !prevState.enabledGeoLocation
    }));
  }

  _handleChange(e) {
    this.setState({
      customPrivacyPolicyUrl: e.target.value,
      errors: {}
    })
  }

  handleSaveClick() {

    let errors = this._validateCustomPolicyUrl();

    this.setState({
      errors: errors
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    let privacyPolicyData = {
      customPrivacyPolicy: this.state.enabledCustomPrivacyPolicy,
      consentType: this.state.consentType,
      enabledGeoLocation: this.state.enabledGeoLocation
    }

    if (this.state.enabledCustomPrivacyPolicy) {
      privacyPolicyData.url = this.state.customPrivacyPolicyUrl
    } else {
      privacyPolicyData.url = 'https://app.paperflite.com/privacy'
    }

    if (this.props.account.privacyPolicy.url != privacyPolicyData.url) {
      this.setState({
        showPrivacyPolicyConfirmation: true,
        privacyPolicyData: privacyPolicyData
      })
    } else {
      this.props.updatePrivacyPolicyControl({ privacyPolicyData: privacyPolicyData, consentRequired: false })
      // .then(() => {
      //   if(!this.props.updating && _.isEmpty(this.props.error)){
      //     toast(
      //       <Toast.Sucess
      //         heading =  {this.localizedPrivaryPolicy.toast.heading}        
      //         description = {this.localizedPrivaryPolicy.toast.description}            
      //       /> , {
      //         type: toast.TYPE.SUCCESS,
      //         position: toast.POSITION.BOTTOM_RIGHT,
      //         autoClose: 3000,
      //     })
      //   }  
      // });
    }
  }

  _validateCustomPolicyUrl() {
    var errors = {};
    if (this.state.enabledCustomPrivacyPolicy &&
      (!this.state.customPrivacyPolicyUrl ||
        this.state.customPrivacyPolicyUrl.trim() == '')) {
      errors['customPolicyUrl'] = this.localizedPrivaryPolicy.error_message;
    }
    return errors;
  }

  render() {
    return (
      <div className={styles.rightContent}>
        <div className={styles.body}>
          <div className={styles.heading}>{this.localizedPrivaryPolicy.title}</div>
          <div className={styles.text}>{this.localizedPrivaryPolicy.sub_text}</div>
          <div className={styles.accessLevel}>
            <i className={cx(!this.state.enabledCustomPrivacyPolicy ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this._handlePolicyChange.bind(this, false)}></i>
            <span>{this.localizedPrivaryPolicy.use}<a href="https://app.paperflite.com/privacy" target="_blank"> {this.localizedPrivaryPolicy.paperflite_privacy_policy}</a></span>
          </div>
          <div className={cx(styles.accessLevel, styles.custom)}>
            <i className={cx(this.state.enabledCustomPrivacyPolicy ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this._handlePolicyChange.bind(this, true)}></i>
            <span>{this.localizedPrivaryPolicy.set_custom_policy}</span>
          </div>
          {this.state.enabledCustomPrivacyPolicy &&
            <div className={cx(styles.inputField)}>
              <input
                ref='emailInput'
                type="text"
                value={this.state.customPrivacyPolicyUrl}
                placeholder={this.localizedPrivaryPolicy.custom_policy_placeholder}
                onChange={this._handleChange.bind(this)}
              />
            </div>
          }
          {this.state.enabledCustomPrivacyPolicy && this.state.errors && this.state.errors.customPolicyUrl &&
            <span className={styles.errorMessage} > <i className='paperflite-danger' /> {this.state.errors.customPolicyUrl} </span>
          }
          <div className={styles.typeHeading}>{this.localizedPrivaryPolicy.consent_type.title}</div>
          <div className={styles.optionSection}>
            <div className={styles.accessLevel}>
              <i className={cx(this.state.consentType === 'MANDATORY' ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this._handleConsentTypeChange.bind(this, 'MANDATORY')}></i>
              <span className={styles.options}>{this.localizedPrivaryPolicy.consent_type.mandatory_content.title}</span>
              <p>{this.localizedPrivaryPolicy.consent_type.mandatory_content.sub_text}</p>
            </div>
            <div className={styles.accessLevel}>
              <i className={cx(this.state.consentType === 'OPTIONAL' ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this._handleConsentTypeChange.bind(this, 'OPTIONAL')}></i>
              <span className={styles.options}>{this.localizedPrivaryPolicy.consent_type.optional_consent.title}</span>
              <p>{this.localizedPrivaryPolicy.consent_type.optional_consent.sub_text}</p>
            </div>
            <div className={styles.accessLevel}>
              <i className={cx(this.state.consentType === 'NONE' ? 'paperflite-tick-selected' : 'paperflite-radio-button-unselected')} aria-hidden="true" onClick={this._handleConsentTypeChange.bind(this, 'NONE')}></i>
              <span className={styles.options}>{this.localizedPrivaryPolicy.consent_type.no_consent.title}</span>
              <p>{this.localizedPrivaryPolicy.consent_type.no_consent.sub_text}</p>
            </div>

          </div>
          <div className={styles.optionSection}>
            <img className={styles.previewImg} src={this._renderPreviewImage()} />
          </div>
        </div>

        <div className={styles.policyTags}>
          <div className={styles.tags}>
            {this.localizedPrivaryPolicy.consent_type.request_consent}
          </div>
          <div className={styles.enablePolicy}>
            <SwitchButton id="enablePolicy" handleCheck={()=>this.onToggleChange()} checked={this.state.enabledGeoLocation} />
          </div>
        </div>

        <div className={styles.buttonTray}>
          <button
            className={styles.button}
            onClick={this.handleSaveClick}>
            <span className={styles.title}>{this.props.updating ? `${this.localizedPrivaryPolicy.consent_type.saving_policy_settings}...` : this.localizedPrivaryPolicy.consent_type.save_policy_settings}</span>
          </button>
        </div>

        <Slider.Dialog width="25vw" show={this.state.showPrivacyPolicyConfirmation}>
          <PrivacyPolicyConfirmationPage privacyPolicyData={this.state.privacyPolicyData}
          onCancel={() => {
            this.setState({
              showPrivacyPolicyConfirmation: false
            })
          }}
        />
        </Slider.Dialog>
      </div>
    );
  }

  _renderPreviewImage() {
    let image = NoneConsentImage
    if (this.state.consentType === 'MANDATORY') {
      image = MandatoryConsentImage
    } else if (this.state.consentType === 'OPTIONAL') {
      image = OptionalConsentImage
    }
    return image;

  }
}

export default PrivacyPolicyControlView;